import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-740ac356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "v3dp__heading" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "v3dp__heading__icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6 8"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      d: "M-9 16V-8h24v24z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 0L1 4l4 4"
    })
  ])
], -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "v3dp__heading__icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6 8"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      d: "M15-8v24H-9V-8z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1 8l4-4-4-4"
    })
  ])
], -1))
const _hoisted_6 = { class: "v3dp__body" }
const _hoisted_7 = { class: "v3dp__subheading" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "v3dp__divider" }, null, -1))
const _hoisted_9 = { class: "v3dp__elements" }
const _hoisted_10 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "v3dp__popout",
    style: _normalizeStyle({ '--popout-column-definition': `repeat(${_ctx.columnCount}, 1fr)` }),
    onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "v3dp__heading__button",
        disabled: _ctx.leftDisabled,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('left')), ["stop","prevent"]))
      }, [
        _renderSlot(_ctx.$slots, "arrow-left", {}, () => [
          _hoisted_3
        ], true)
      ], 8, _hoisted_2),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.headingClickable ? 'button' : 'span'), {
        class: "v3dp__heading__center",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('heading')), ["stop","prevent"]))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "heading", {}, undefined, true)
        ]),
        _: 3
      })),
      _createElementVNode("button", {
        class: "v3dp__heading__button",
        disabled: _ctx.rightDisabled,
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('right')), ["stop","prevent"]))
      }, [
        _renderSlot(_ctx.$slots, "arrow-right", {}, () => [
          _hoisted_5
        ], true)
      ], 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      ('subheading' in _ctx.$slots)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "subheading", {}, undefined, true)
            ]),
            _hoisted_8
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "body", {}, () => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.key,
              disabled: item.disabled,
              class: _normalizeClass({ selected: item.selected }),
              onClick: _withModifiers(($event: any) => (_ctx.$emit('elementClick', item.value)), ["stop","prevent"])
            }, [
              _createElementVNode("span", null, _toDisplayString(item.display), 1)
            ], 10, _hoisted_10))
          }), 128))
        ], true)
      ])
    ])
  ], 36))
}